import React from 'react';
import { QuizApp } from './components/QuizApp';
export function App() {
  return <QuizApp data-id="element-0" />;
}